@if (loading) {
<mat-spinner class="loading-spinner" [diameter]="70"></mat-spinner>
} @if (productDetail) {
<div class="review-container">
    <div class="review-content container">
        <div class="left-section">
            <app-product-image-gallery
                [showWishlistIcon]="false"
                [show360View]="false"
                [productId]="productId"
                class="product-image-gal"
            ></app-product-image-gallery>
        </div>

        <div class="right-section">
            <div class="details-section">
                <div class="subCategory-container">
                    <span class="subCategory">{{ productDetail.subCategory }}</span>
                    <mat-icon svgIcon="wishlist"></mat-icon>
                </div>
                <p class="product-name font-poppins">{{ productDetail.name }}</p>
                <p class="block-info">{{ productDetail.modelQuantityJson?.totalBlock }} Building Blocks</p>

                <div class="price-info">
                    @if (productDetail.discountedPrice) {
                    <p class="discounted-price font-poppins">
                        {{ productDetail.discountedPrice | currency: "INR" }}
                    </p>
                    <p class="price font-inter">
                        {{ productDetail.price | currency: "INR" }}
                    </p>
                    } @else {
                    <p class="discounted-price font-poppins">
                        {{ productDetail.price | currency: "INR" }}
                    </p>
                    }
                </div>

                <p class="free-shipping">+ Free Shipping on orders over Rs. 200.00</p>
            </div>

            <div class="cutomer-rating">
                <div class="rating-heading-container">
                    <p class="rating-title font-popins">Customer Ratings</p>

                    <p class="rating-container">
                        <span class="average-rating-count font-poppins">{{ productDetail.averageRating }}</span>
                        <span class="rating-review-container">
                            <span class="rating-star-container">
                                @for (star of getStars(productDetail.averageRating ?? 0); track $index) {
                                <mat-icon
                                    [svgIcon]="star === 'full' ? 'fullstar' : star === 'half' ? 'halfstar' : 'fullstar'"
                                    class="star-icon"
                                    [ngClass]="{
                                        'filled-star': star === 'full',
                                        'half-star': star === 'half'
                                    }"
                                >
                                </mat-icon>
                                }
                            </span>
                            <span class="review-count">{{ productDetail.reviews?.length }} reviews</span>
                        </span>
                    </p>
                </div>
                @for (item of distributionEntries; track $index) {
                <div class="rating-bar-row">
                    <div class="count-rating-content">
                        <span>{{ item[0] }}</span
                        ><mat-icon class="rating-star">star</mat-icon>
                    </div>
                    <div class="bar-container">
                        <div class="bar-filled" [ngStyle]="{ width: (item[1] / totalcount) * 100 + '%' }"></div>
                    </div>
                    <span>{{ item[1] }}</span>
                </div>
                }
            </div>

            <div class="customer-reviews-section">
                <p class="customer-reviews-title font-poppins">Customer Reviews</p>

                <div class="customer-reviews">
                    @for (item of reviews; track $index) { @if (item?.review) {
                    <div class="review">
                        <div class="name-profile-container">
                            <img [src]="item.otp?.user?.profileImage" class="profile-image" />
                            <div class="name-rating-container">
                                <span class="name font-poppins">{{ item.name }}</span>
                                <span class="rating-star-container">
                                    @for (star of getStars(item.rating); track $index) {
                                    <mat-icon
                                        [svgIcon]="
                                            star === 'full' ? 'fullstar' : star === 'half' ? 'halfstar' : 'fullstar'
                                        "
                                        class="star-icon"
                                        [ngClass]="{
                                            'filled-star': star === 'full',
                                            'half-star': star === 'half'
                                        }"
                                    >
                                    </mat-icon>
                                    }
                                </span>
                            </div>
                        </div>
                        <p>{{ item.review }}</p>
                    </div>
                    } }
                </div>
            </div>
        </div>
    </div>

    <div class="product-property-container">
        <div class="product-property-content container">
            <div class="section">
                <span class="icon-container blue-gradient">
                    <mat-icon svgIcon="box" class="icon"></mat-icon>
                </span>

                <div class="property">
                    <p class="title font-poppins">What's Included</p>
                    <p class="icon-label-container">
                        <mat-icon svgIcon="tick" class="tick-icon"></mat-icon> <span>216 building blocks</span>
                    </p>
                    <p class="icon-label-container">
                        <mat-icon svgIcon="tick" class="tick-icon"></mat-icon> <span>Instructional manual</span>
                    </p>
                    <p class="icon-label-container">
                        <mat-icon svgIcon="tick" class="tick-icon"></mat-icon> <span>Storage bag</span>
                    </p>
                    <p class="icon-label-container">
                        <mat-icon svgIcon="tick" class="tick-icon"></mat-icon> <span>Bonus stickers</span>
                    </p>
                </div>
            </div>

            <div class="section">
                <span class="icon-container pink-gradient">
                    <mat-icon svgIcon="safematerial" class="icon"></mat-icon>
                </span>

                <div class="property">
                    <p class="title font-poppins">Safety Info</p>
                    <p class="icon-label-container">
                        <mat-icon svgIcon="tick" class="tick-icon"></mat-icon> <span>Non-toxic materials</span>
                    </p>
                    <p class="icon-label-container">
                        <mat-icon svgIcon="tick" class="tick-icon"></mat-icon> <span>CE certified</span>
                    </p>
                    <p class="icon-label-container">
                        <mat-icon svgIcon="tick" class="tick-icon"></mat-icon> <span>No sharp edges</span>
                    </p>
                    <p class="icon-label-container">
                        <mat-icon svgIcon="tick" class="tick-icon"></mat-icon> <span>Tested & approved</span>
                    </p>
                </div>
            </div>

            <div class="section">
                <span class="icon-container yellow-gradient">
                    <mat-icon svgIcon="age" class="icon"></mat-icon>
                </span>

                <div class="property">
                    <p class="title font-poppins">Age Group</p>
                    <p class="label-container">
                        <span class="age font-poppins">6+</span>
                        <span class="year">Years old</span>
                        <span class="label-age">Perfect for kids aged 6 and above</span>
                    </p>
                </div>
            </div>

            <div class="section">
                <span class="icon-container green-gradient">
                    <mat-icon svgIcon="leave" class="icon"></mat-icon>
                </span>

                <div class="property">
                    <p class="title font-poppins">Materials</p>
                    <p class="label">ABS plastic</p>
                    <p class="label">BPA-free</p>
                    <p class="label">Eco-friendly</p>
                    <p class="label">Durable</p>
                </div>
            </div>
        </div>
    </div>
</div>
}
